import Swal from "sweetalert2";
import Escudo from "../assets/img/escudo.svg";
export const fireEmptyInputSwal = () => {
  Swal.fire({
    title: "Error",
    text: "Por favor complete todos los campos.",
    icon: "error",
    confirmButtonColor: "#f44336",
    timer: 2000,
  });
};

export const fireInvalidEmailSwal = () => {
  Swal.fire({
    title: "Error",
    text: "Por favor ingrese un email valido.",
    icon: "error",
    confirmButtonColor: "#f44336",
    timer: 2000,
  });
};

export const firePostSuccessModal = (handler, idSolicitud, timer = true) => {
  Swal.fire({
    title: "<h2>Realizaste la solicitud de acreditaciones</h2>",
    html: `<p class='mb-4'>Recibirás el estado de tus acreditaciones en tu correo electónico</p><p>Tu id unico solicitud es <span class='fw700'>${idSolicitud}</span></p>`,
    iconHtml: "<img src='/img/notas.png' />",
    confirmButtonText: "Finalizar",
    confirmButtonClass: "btn login-btn",
    timer: timer && 5000,
    customClass: { confirmButton: "btn login-btn enabled" },
    buttonsStyling: false,
  }).then((result) => {
    handler();
  });
};

export const fireGenericErrorModal = (message) => {
  Swal.fire({
    title: "Error",
    text: message || "Tuvimos un error procesando la solicitud. Intentelo de nuevo en la brevedad. ",
    icon: "error",
    confirmButtonColor: "#f44336",
    timer: 2000,
  });
};

export const firePasswordRecoverySwal = (handler) => {
  Swal.fire({
    title: "Confirmar reinicio",
    iconHtml: `<img src='${Escudo}' />`,
    text: "Te pedimos que confirmes que queres reiniciar tu clave. En caso de hacerlo, recibirás un email con más instrucciones.",
    confirmButtonColor: "#f44336",
    confirmButtonText: "Confirmar",
    showCancelButton: true,
    cancelButtonColor: "#767676",
    cancelButtonText: "Cancelar",
  }).then(async (result) => {
    if (!result.isConfirmed) return;
    handler();
  });
};

export const fireMailSentSwal = async () => {
  Swal.fire({
    title: "Enviado",
    iconHtml: `<img src='${Escudo}' />`,
    text: "Hemos enviado más información a tu casilla de correo.",
    confirmButtonColor: "#f44336",
    confirmButtonText: "Confirmar",
    timer: 2000,
  });
};

export const fireMailErrorSwal = () => {
  Swal.fire({
    title: "Error",
    text: "Tuvimos un error procesando la solicitud. Intentelo de nuevo en la brevedad. Si el error persiste ponete en contacto con nosotros.",
    icon: "error",
    confirmButtonColor: "#f44336",
    timer: 2000,
  });
};

export const fireWrongExtention = async () => {
  Swal.fire({
    title: "Formato Inválido",
    text: "El archivo que seleccionó debe ser de extension .png, .jpg o .jpeg",
    icon: "error",
    confirmButtonColor: "#f44336",
    timer: 50000,
  });
};

export const fireDisclaimerEventos = async () => {
  Swal.fire({
    title: "La acreditacion no ha finalizado aún",
    iconHtml: `<img src='${Escudo}' />`,
    text: "Elija un evento y complete los formularios",
    confirmButtonColor: "#f44336",
    confirmButtonText: "Continuar Acreditación",
    timer: 10000,
  });
};